<div class="sunset-banner-container">
	<span class="title"> {{ "new_way_to_invest" | translate }} </span>
	@if (isPortfolioBanner()) {
		<span class="description"> {{ "sunset_digi_portfolio_banner_text" | translate: [ownedAssets()] }}</span>
	} @else {
		<span class="description"> {{ "sunset_digi_banner_text" | translate }}</span>
	}
	<a class="learn-more" [href]="getMoreInfoLink()" [target]="'_blank'"> {{ "more_information" | translate }}</a>
</div>
